import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

export const createNetplusReceiptApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/netplus/receipts`, payload);

export const updateNetplusReceiptApi = (id, payload) =>
  axios.patch(`${API_BASE_URL}/api/netplus/receipts/${id}`, payload);

export const transferNetplusToEmployeeApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/netplus/transfer-to-employee`, payload);
